import axios from "axios";
import { computed, shallowRef, triggerRef, watch } from "vue";
import { APIResponse, UserDto } from "../api-contract/api-contract";
import { appLanguageSwitcherModel } from "../components/app-language-switcher/app-language-switcher.model";
import { sessionModel } from "@/shared/state/session.model";
import { routerModel } from "@/router/router.model";
import { appAxios } from "@/core/utils/appAxios";

export class CurrentUserModel {
    userDto = shallowRef<UserDto | undefined>();
    userDtoPresent = false;
    avatar = shallowRef<string | undefined>();

    constructor() {
        this.userDto.value = undefined;
        this.avatar.value = undefined;

        watch(
            () => ({
                lang: appLanguageSwitcherModel.lang.value,
                accessToken: sessionModel.sessionDto.value,
            }),
            async ({ accessToken, lang }) => {
                if (!accessToken) {
                    return;
                }
                await this.fetchCurrentUser();
            },
            { immediate: true },
        );
    }

    /* API Connectivity --------------------------------------------------------------------------------------------- */
    async fetchCurrentUser() {
        await appAxios.value
            .get<APIResponse<UserDto>>(`/client/web/user`)
            .then((response) => {
                if (response?.status !== 200 || response?.data?.status.code !== 200) {
                    if (response?.status === 401 || response?.data?.status.code === 401) {
                        this.userDtoPresent = false;
                        this.userDto.value = undefined;
                    }

                    if (response.data.status.code === 409) {
                        routerModel.router.push("/signup/thanks");
                    }
                }

                this.userDto.value = response.data.data;
                this.userDtoPresent = true;
            })
            .catch(console.log);
    }
}

export const currentUserModel = new CurrentUserModel();
